import { useSelector } from 'react-redux';
import { IRootState } from '../../../redux/reducers-types';

// Provides root state typings for easier state access
export const useAppSelector = <T>(selectorFn: (state: IRootState) => T) =>
    useSelector<IRootState, T>(selectorFn);
